<template>
    <div>
        <div class="mb-4">
            <b>{{ $t('co.address_data.leads.delivery_address') }}</b>
        </div>

        <div class="mb-2">
            <b-form-radio-group v-model="radioValue" name="faaren_customer" inline>
                <b-form-radio value="private_customer">
                    {{ $t('co.personal_data.customer_type.private') }}
                </b-form-radio>
                <b-form-radio value="business_customer">
                    {{ $t('co.personal_data.customer_type.business') }}
                </b-form-radio>
            </b-form-radio-group>
        </div>
        
        <div class="row mb-2" v-if="radioValue === 'business_customer'">
            <b-form-group 
                :label="$t('nav.company')" 
                label-for="faaren_company_name" 
                class="col-12 col-md-5 mr-md-2 mb-2"
            >
                <b-form-input
                    id="faaren_company_name"
                    name="user_company_name"
                    :placeholder="$t('nav.company')"
                    v-model="companyname"
                    type="text"
                ></b-form-input>
            </b-form-group>
        </div>

        <div class="row mb-2">
            <b-form-group 
                :label="$t('co.personal_data.salutation')" 
                label-for="faaren_salutation" 
                class="col-12 col-md-5 mr-md-2 mb-2"
            >
                
                <b-form-select
                    id="faaren_salutation"
                    name="faaren_salutation"
                    v-model="salutation"
                >
                    <b-form-select-option value="choose" disabled>{{ $t('co.personal_data.salutation.choose') }}</b-form-select-option>
                    <b-form-select-option value="mr">{{ $t('co.personal_data.salutation.mr') }}</b-form-select-option>
                    <b-form-select-option value="mrs">{{ $t('co.personal_data.salutation.ms') }}</b-form-select-option>
                    <b-form-select-option value="divers">{{ $t('co.personal_data.salutation.divers') }}</b-form-select-option>
                    <b-form-select-option value="notspecified">{{ $t('co.personal_data.salutation.null') }}</b-form-select-option>
                </b-form-select>
            </b-form-group>
        </div>

        <div class="row mb-2">
            <b-form-group 
                :label="$t('co.personal_data.first_name')" 
                label-for="faaren_firstname" 
                class="col-12 col-md-5 mr-md-2 mb-2"
            >
                <b-form-input
                    id="faaren_firstname"
                    name="user_firstname"
                    :placeholder="$t('co.personal_data.first_name')"
                    v-model="firstname"
                    type="text"
                    required
                ></b-form-input>
            </b-form-group>
            
            <b-form-group
                :label="$t('co.personal_data.last_name')"
                label-for="faaren_lastname"
                class="col-12 col-md-5"
            >
                <b-form-input
                    id="faaren_lastname"
                    name="user_lastname"
                    :placeholder="$t('co.personal_data.last_name')"
                    v-model="lastname"
                    type="text"
                    required
                ></b-form-input>
            </b-form-group>
        </div>

        <div class="row mb-2">
            <b-form-group 
                :label="$t('co.personal_data.birthday')" 
                label-for="faaren_birthday" 
                class="col-12 col-md-5 mr-md-2 mb-2"
            >
                <b-form-input
                    id="faaren_birthday"
                    name="user_birthday"
                    :placeholder="$t('co.personal_data.birthday')"
                    v-model="birthday"
                    type="date"
                    min="1900-01-01"
                    required
                ></b-form-input>
                <small v-if="ageError" class="text-danger">{{ $t('co.personal_data.ageError') }}</small>
            </b-form-group>
        </div>

        <div class="mb-4 mt-4">
            <b>{{ $t('co.address_data.leads.contact_address') }}</b>
        </div>

        <div class="row mb-2">
            <b-form-group 
                :label="$t('co.address_data.street')" 
                label-for="faaren_street" 
                class="col-12 col-md-5 mr-md-2 mb-2"
            >
                <b-form-input
                    id="faaren_street"
                    name="user_street"
                    :placeholder="$t('co.address_data.street')"
                    v-model="street"
                    type="text"
                    required
                ></b-form-input>
            </b-form-group>

            <b-form-group
                :label="$t('co.address_data.number')"
                label-for="faaren_street_number"
                class="col-12 col-md-5"
            >
                <b-form-input
                    id="faaren_street_number"
                    name="user_street_number"
                    :placeholder="$t('co.address_data.number.placeholder')"
                    v-model="streetnumber"
                    type="text"
                    required
                ></b-form-input>
            </b-form-group>
        </div>

        <div class="row mb-2">
            <b-form-group 
                :label="$t('co.address_data.post_code')" 
                label-for="faaren_post_code" 
                class="col-12 col-md-5 mr-md-2 mb-2"
            >
                <b-form-input
                    id="faaren_post_code"
                    name="user_post_code"
                    :placeholder="$t('co.address_data.post_code.placeholder')"
                    v-model="postalcode"
                    type="text"
                    required
                ></b-form-input>
            </b-form-group>

            <b-form-group
                :label="$t('co.address_data.location')"
                label-for="faaren_location"
                class="col-12 col-md-5"
            >
                <b-form-input
                    id="faaren_location"
                    name="user_location"
                    :placeholder="$t('co.address_data.location')"
                    v-model="city"
                    type="text"
                    required
                ></b-form-input>
            </b-form-group>
        </div>

        <div class="row mb-2">
            <b-form-group
                :label="$t('co.address_data.country')"
                label-for="faaren_country"
                class="col-12 col-md-5 mr-md-2 mb-2"
            >   
                <b-form-select
                    id="faaren_country"
                    name="user_country"
                    v-model="country.value"
                    :state="country.state"
                    aria-describedby="delivery-country-error"
                >
                    <b-form-select-option
                        v-for="option in country.options"
                        :value="option.value"
                        :key="option.value"
                    >
                        {{ $t(`countries.${option.text}`) }}
                    </b-form-select-option>
                </b-form-select>
            </b-form-group>
        </div>

        <div class="mb-4 mt-4">
            <b>{{ $t('co.address_data.leads.contact') }}</b>
        </div>

         <div class="row mb-3">
            <b-form-group
                    :label="$t('cdb.profile.form.email.label')"
                    label-for="faaren_location"
                    class="col-12 col-md-5"
                >
                    <b-form-input
                        id="faaren_email"
                        name="user_email"
                        :placeholder="$t('cdb.profile.form.email.label')"
                        v-model="email"
                        type="text"
                        required
                    ></b-form-input>
            </b-form-group>

            <b-form-group
                :label="$t('global.fields.phone.label')"
                label-for="faaren_phone_number"
                class="col-12 col-md-5"
            >
                <b-form-input
                    id="faaren_phone_number"
                    name="user_phone_number"
                    :placeholder="$t('global.fields.phone.label')"
                    v-model="telephone"
                    type="text"
                    required
                ></b-form-input>
            </b-form-group>
        </div>

    </div>
</template>

<script>
import countries from '../../stores/countries'
import { EventBus } from '../../event-bus';

import {
    BFormInput, BFormGroup, BFormSelect, BFormSelectOption, BFormTextarea, BFormRadio, BFormRadioGroup
} from "bootstrap-vue"

export default {
    name: 'CheckoutLeadsAddress',
    components: {
        BFormInput,
        BFormGroup,
        BFormSelect,
        BFormSelectOption,
        BFormTextarea,
        BFormRadio,
        BFormRadioGroup
    },

    data() {
        return {
            companyname: '',
            firstname: '',
            lastname: '',
            birthday: '',
            telephone: '',
            street: '',
            streetnumber: '',
            postalcode: '',
            phonenumber: '',
            salutation: 'choose',
            city: '',
            email: '',
            country: {
                value: this.$root.whitelabel.state.contact.address.country,
                state: null,
                options: countries.entries
            },
            ageError: false,
            radioValue: 'private_customer'
        }
    },

    methods: {
        validateAge(userBirthday){
            const today = new Date();
            const birthDate = new Date(userBirthday)

            let age = today.getFullYear() - birthDate.getFullYear()
            const birthdayPast = today.getMonth() > birthDate.getMonth() || (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate())
            
            if (!birthdayPast) {
                age = age - 1;
            }

            return age > 18;
        },
    },

    watch: {
        birthday: function (newVal) {
            if (!this.validateAge(newVal)) {
                this.ageError = true;
                EventBus.$emit('leads-age-validation', { value: false });
            } else {
                this.ageError = false;
                EventBus.$emit('leads-age-validation', { value: true });
            }
        }
    }
}
</script>